<template>
  <div>
    <Modal v-if="isPlanerOpen">
      <template #default>
        <CheckpointsPlanner :entity="entity"
                            @done="plannerDone"
        ></CheckpointsPlanner>
      </template>
      <template #controls>
        <button class="asd-btn-cancel"
                @click="isPlanerOpen = false"
        >
          Zavřít
        </button>
      </template>
    </Modal>
    <button class="asd-btn-confirm"
            @click="isPlanerOpen = true"
    >
      Automatický plánovač checkpointů
    </button>
    <table v-if="loaded"
           class="asd-table"
    >
      <thead>
        <tr class="table-heading">
          <th>
            <!-- <button class="asd-btn-confirm asd-btn-single-icon"
                    @click="isAddOpened = true"
            >
              <i class="fas fa-plus"></i>
            </button> -->
          </th>
          <th>Jméno</th>
          <th>Splnit do</th>
          <th>Zpracováno?</th>
          <th>Je hotovo?</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="row in entries"
            :key="`checkpoint-row-${row.id_checkpoint}`"
        >
          <td>
            <ActiveButton
              v-help.mouse="`Smazat PA`"
              class="asd-btn-delete"
              :click="deleteEntry"
              :confirmText="`Opravdu chcete smazat tuto polozku?`"
              :fncParam="row"
            >
              <i class="fas fa-trash"></i>
            </ActiveButton>
            <ActiveButton
              v-if="!row.is_done"
              v-help.mouse="`Smazat PA`"
              class="asd-btn-confirm"
              :click="confirmEntry"
              :confirmText="`Opravdu chcete potvrdit ze je tento bod hotov?`"
              :fncParam="row"
            >
              <i class="fas fa-check"></i>
            </ActiveButton>
          </td>
          <td>{{ row.name }}</td>
          <td>{{ row.deadline }}</td>
          <td>
            <i v-if="row.last_processed"
               style="color: green"
               class="fas fa-check"
            ></i>
          </td>
          <td v-if="row.is_done"
              style="color: green"
          >
            Ano
          </td>
          <td v-else></td>
        </tr>
      </tbody>
    </table>
    <Spinner v-else></Spinner>
  </div>
</template>

<script>
import { get, sortBy } from 'lodash'
import Spinner from 'CORE/components/utilities/spinner'
import EventBus from 'CORE/bus'
import axios from 'axios'
import ActiveButton from 'CORE/components/form/active-button'
import Modal from 'CORE/components/modal/modal'
import CheckpointsPlanner from './planner.vue'

export default {
    name: 'CheckpointsList',
    components: {
        Spinner,
        ActiveButton,
        Modal,
        CheckpointsPlanner,
    },
    props: {
        entity: {
            type: String,
            required: true,
            default: () => null,
        },
    },
    data() {
        return {
            entries: [],
            loaded: false,
            isAddOpened: false,
            isPlanerOpen: false,
        }
    },
    async mounted() {
        this.loadData()
    },
    methods: {
        async loadData() {
            this.loaded = false
            try {
                this.entries = sortBy(
                    get(await axios.get(`/workflow/checkpoints/list/${this.entity}`), 'data.data', []),
                    entry => {
                        return get(entry, 'deadline')
                    }
                )
            } catch (e) {
                EventBus.$emit('FLASH_USER_ERROR', { message: e })
            } finally {
                this.loaded = true
            }
        },
        async confirmEntry(entry) {
            try {
                entry.is_done = true
                await axios.put(`/workflow/checkpoints/update`, entry)
            } catch (e) {
                EventBus.$emit('FLASH_USER_ERROR', { message: e })
            } finally {
                await this.loadData()
            }
        },
        async plannerDone() {
            this.isPlanerOpen = false
            this.loadData()
        },
        async deleteEntry(entry) {
            await axios.delete(`/workflow/checkpoints/delete/${entry.id_checkpoint}`)
            await this.loadData()
        },
    },
}
</script>

<style lang="scss" scoped>
.add-box {
    margin: 10px;
}
</style>
